import { get_name_value, get_id_value, } from "../ap214_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
import StepEntityBase from "../../step/step_entity_base.js";
///**
// *  */
export class address extends StepEntityBase {
    get type() {
        return EntityTypesAP214.ADDRESS;
    }
    get internal_location() {
        if (this.internal_location_ === void 0) {
            this.internal_location_ = this.extractString(0, true);
        }
        return this.internal_location_;
    }
    get street_number() {
        if (this.street_number_ === void 0) {
            this.street_number_ = this.extractString(1, true);
        }
        return this.street_number_;
    }
    get street() {
        if (this.street_ === void 0) {
            this.street_ = this.extractString(2, true);
        }
        return this.street_;
    }
    get postal_box() {
        if (this.postal_box_ === void 0) {
            this.postal_box_ = this.extractString(3, true);
        }
        return this.postal_box_;
    }
    get town() {
        if (this.town_ === void 0) {
            this.town_ = this.extractString(4, true);
        }
        return this.town_;
    }
    get region() {
        if (this.region_ === void 0) {
            this.region_ = this.extractString(5, true);
        }
        return this.region_;
    }
    get postal_code() {
        if (this.postal_code_ === void 0) {
            this.postal_code_ = this.extractString(6, true);
        }
        return this.postal_code_;
    }
    get country() {
        if (this.country_ === void 0) {
            this.country_ = this.extractString(7, true);
        }
        return this.country_;
    }
    get facsimile_number() {
        if (this.facsimile_number_ === void 0) {
            this.facsimile_number_ = this.extractString(8, true);
        }
        return this.facsimile_number_;
    }
    get telephone_number() {
        if (this.telephone_number_ === void 0) {
            this.telephone_number_ = this.extractString(9, true);
        }
        return this.telephone_number_;
    }
    get electronic_mail_address() {
        if (this.electronic_mail_address_ === void 0) {
            this.electronic_mail_address_ = this.extractString(10, true);
        }
        return this.electronic_mail_address_;
    }
    get telex_number() {
        if (this.telex_number_ === void 0) {
            this.telex_number_ = this.extractString(11, true);
        }
        return this.telex_number_;
    }
    get name() {
        return get_name_value(this);
    }
    get url() {
        return get_id_value(this);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
address.query = [EntityTypesAP214.ADDRESS];
address.expectedType = EntityTypesAP214.ADDRESS;
